import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        is_initdata_loading: false,
        products: []
    },
    mutations: {
        setIsInitdataLoading(state, obj) {
            state.is_initdata_loading = obj;
        },
        setProducts(state, obj) {
            state.products = obj;
        }
    }
})